export const zoomPreviewMixin = {
	data: function() {
		return {
			previewStyle: {
				transform: 'none',
				marginBottom: 0
			}
		}
	},
	methods: {
		zoomPreview(isPreview = true) {
			const preview = this.$refs.preview;
			const hideImg = preview.querySelectorAll('img')[1];
			const { scrollHeight, offsetWidth } = preview;
			const parentWidth = window.outerWidth - 30;

			if (parentWidth <= offsetWidth) {
				this.previewStyle.transform = `scale(${this.calculateScale(parentWidth, offsetWidth)})`;
				this.previewStyle.marginBottom =
					`${this.calculateMargin(scrollHeight, this.calculateScale(parentWidth, offsetWidth))}px`;

				if (isPreview) {
					setTimeout(() => {
						const hideImgY = hideImg.getBoundingClientRect().y;
						const previewY = preview.getBoundingClientRect().y;
						preview.querySelector('.preview').style.top =
							`${(hideImgY - previewY) / this.calculateScale(parentWidth, offsetWidth)}px`;
					}, 250)
				}
			}
		},
		calculateScale(parentWidth, previewWidth) {
			return 1 + (parentWidth - previewWidth) / previewWidth;
		},
		calculateMargin(previewHeight, diff) {
			return -previewHeight * (1 - diff)
		}
	}
};